import { useCallback, useEffect, useState } from "react";

import { SOCKET_MESSAGE_TYPE } from "@is/constants";
import { sendErrorMessageToSlack } from "@is/utils/slack";

import { webSocketWorker } from "../../workers";

export function useWebSocketConnect() {
  const [connected, setConnected] = useState(false);

  const connect = useCallback(() => {
    webSocketWorker.postMessage({
      type: SOCKET_MESSAGE_TYPE.CHECK_CONNECTION_STATUS,
    });
  }, []);

  const disconnect = useCallback(() => {
    webSocketWorker.postMessage({
      type: SOCKET_MESSAGE_TYPE.DISCONNECT,
    });
  }, []);

  const handleMessage = useCallback((event) => {
    switch (event.data.type) {
      case SOCKET_MESSAGE_TYPE.CONNECTION_STATUS: {
        const { connected } = event.data;

        if (connected) {
          setConnected(connected);
        } else {
          setConnected(false);

          webSocketWorker.postMessage({
            type: SOCKET_MESSAGE_TYPE.CONNECT,
          });
        }

        break;
      }
      case SOCKET_MESSAGE_TYPE.CONNECT_FAILURE: {
        const { notifyInSlack } = event.data;
        if (notifyInSlack) {
          sendErrorMessageToSlack("WS connection error");
        }
        break;
      }
      case SOCKET_MESSAGE_TYPE.CONNECTED: {
        setConnected(true);
        break;
      }
      default:
        break;
    }
  }, []);

  useEffect(() => {
    webSocketWorker.addEventListener("message", handleMessage);

    return () => {
      webSocketWorker.removeEventListener("message", handleMessage);
    };
  }, [handleMessage]);

  return { connected, connect, disconnect };
}
